import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Grid, GridItem, IconButton, Text } from '@chakra-ui/react';
import { memo, useCallback, useState } from 'react';
import { useT } from '@progress-fe/core';
import cn from 'clsx';
import { Svg } from '../../../../base';
import { InputNumber } from '../../../../inputs';
import { BlendRange } from './components';
import s from './BlendRangesTable.module.css';
const BlendRangesTableFC = ({ ranges, formData, suffix, isReadOnly, isDialog, onCreateRange, onDeleteRange, onRangeChanged, onToggleDialog }) => {
    const { t } = useT();
    const [splitValue, setSplitValue] = useState(null);
    const [invalidSplitValue, setInvalidSplitValue] = useState(false);
    const fieldConfig = formData.fieldConfig;
    const handleChangeSplitValue = useCallback((value) => {
        setInvalidSplitValue(false);
        setSplitValue(value);
    }, []);
    const handleCreateRange = () => {
        if (splitValue === null) {
            return;
        }
        const splitNumVal = Number(splitValue);
        const rangeIdxToSplit = ranges.findIndex((r) => {
            return (Number(r[fieldConfig.min.name]) < splitNumVal &&
                Number(r[fieldConfig.max.name]) > splitNumVal);
        });
        if (rangeIdxToSplit < 0) {
            setInvalidSplitValue(true);
            return;
        }
        setSplitValue(null);
        onCreateRange(splitValue, rangeIdxToSplit);
    };
    const handleDeleteRange = (idx) => {
        onDeleteRange(idx);
    };
    const handleRangeChanged = (rangeVal, idx) => {
        onRangeChanged(rangeVal, idx);
    };
    const handleDialogClick = useCallback(() => {
        onToggleDialog();
    }, [onToggleDialog]);
    const fieldsTitles = [fieldConfig.min.title, fieldConfig.max.title].concat(formData.fieldConfig.fields.map((f) => f.title));
    return (_jsxs(Flex, { p: "4px 0", flexDirection: "column", gap: "8px", className: cn(s.oilBlendTable, isDialog && s.dialog), children: [_jsxs(Grid, { gridTemplateColumns: `155px 1fr`, border: "1px", borderColor: "border", overflow: "hidden", children: [_jsxs(Grid, { borderRight: "1px solid", borderColor: "border", gap: "4px", p: "4px 0 4px 4px", alignItems: "center", autoRows: "24px", children: [fieldsTitles.map((title) => (_jsx(Text, { children: title }, title))), !isReadOnly && _jsx(Text, { children: t('jsfields.OilBlendModel.deleteRange') })] }), _jsx(GridItem, { overflow: "hidden", children: _jsx(Flex, { overflow: "auto", gap: "4px", p: "4px 0 4px 4px", children: ranges.map((range, idx) => (_jsx(BlendRange, { isReadOnly: isReadOnly, className: s.rangeColumn, rangeValue: range, formData: formData, suffix: suffix, isFirst: idx === 0, isLast: idx === ranges.length - 1, onDelete: () => handleDeleteRange(idx), onChange: (val) => handleRangeChanged(val, idx) }, idx))) }) })] }), _jsxs(Flex, { gap: "4px", children: [_jsx(InputNumber, { size: "xs", variant: "outline", sx: { width: '100%' }, value: splitValue ?? undefined, isInvalid: invalidSplitValue, min: fieldConfig.min.value, max: fieldConfig.max.value, isDisabled: isReadOnly, onChange: handleChangeSplitValue }), _jsx(Button, { variant: "ghost", size: "smSquare", width: "100%", onClick: handleCreateRange, isDisabled: isReadOnly || splitValue === null || invalidSplitValue, children: t('jsfields.OilBlendModel.addRange') }), !isDialog && (_jsx(IconButton, { flexShrink: 0, size: "smSquare", "aria-label": "", variant: "ghost", icon: _jsx(Svg, { size: "s12", name: "Expand" }), onClick: handleDialogClick }))] })] }));
};
export const OilBlendRangesTable = memo(BlendRangesTableFC);
//# sourceMappingURL=BlendRangesTable.js.map